document.querySelectorAll('[data-gc-hp]').forEach(function (wrap) {
  var items = wrap.querySelectorAll('.gc-hp-item');
  var shots = wrap.querySelectorAll('.gc-hp-shot');
  items.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = btn.getAttribute('data-idx');
      items.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      shots.forEach(function (s) { s.classList.toggle('gc-hp-active', s.getAttribute('data-idx') === idx); });
    });
  });
});
